module.exports = __webpack_public_path__ + "img/brand-logo-white-4062eb3.png";